import React from 'react';

import Spinner from 'react-spinner-material';
import {
  GraphBarCustomLateralTriplo,
  // GraphBarCustomLateral,
  // GraphBarExpansivCard,
  // GraphBarGrouped,
  NewGraphBar,
  // NewGraphBarCustom,
  NewGraphBarPorte,
  PizzaChart,
} from '../../../utils/newGraphsBar';
import styles from './styles.module.scss';

export default function AtendimentosSSE({
  usuariosApp,
  total,
  statusEnvio,
  porte,
  porteMei,
  porteMe,
  porteEpp,
  porcemUsuariosApp,
  porcemStatusEnvio,
  hora,
  hoje,
  dia,
  ufCidadeAtendente,
  recorrenciaPjSse,
  semAnotacao,
  semPlanoAcao,
  semFoto,
  semArquivo,
  isLoadingUsuariosApp,
  isLoadingTotal,
  isLoadingStatusEnvio,
  isLoadingPorte,
  isLoadingPorteMei,
  isLoadingPorteMe,
  isLoadingPorcemUsuariosApp,
  isLoadingPorteEpp,
  isLoadingPorcemStatusEnvio,
  isLoadingHora,
  isLoadingHoje,
  isLoadingDia,
  isLoadingUfCidadeAtendente,
  isLoadingRecorrenciaPjSse,
  isLoadingSemAnotacao,
  isLoadingSemPlanoAcao,
  isLoadingSemFoto,
  isLoadingSemArquivo,
}) {
  const renderTotal = () => (
    <div className={isLoadingTotal ? styles.render_spinner_container : null}>
      {isLoadingTotal && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingTotal && (
        <NewGraphBar
          dataGraphs={total.atendimentos}
          total={
            total.total === 0 ||
            total.total === 'NaN' ||
            total.total === undefined
              ? '0'
              : total.total
          }
          label="total"
          position="mes*total"
          subLabel="atendimentos"
          labelModal="total"
          date={total.data}
          tipoAtendimento="SSE"
        />
      )}
    </div>
  );

  const renderHoje = () => (
    <div className={isLoadingHoje ? styles.render_spinner_container : null}>
      {isLoadingHoje ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={hoje.atendimentosHora}
          total={
            hoje.total === 0 ||
            hoje.total === 'NaN' ||
            hoje.total === undefined ||
            hoje.total === null
              ? '0'
              : hoje?.total
          }
          label="total hoje"
          subLabel="atendimentos"
          labelModal="total hoje"
          position="hora*total"
          date={hoje.horaModal}
          tipoAtendimento="SSE"
        />
      )}
    </div>
  );

  // const renderHora = () => (
  //   <div className={isLoadingHora ? styles.render_spinner_container : null}>
  //     {isLoadingHora ? (
  //       <div className={styles.spinner_style}>
  //         <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
  //       </div>
  //     ) : (
  //       <NewGraphBar
  //         dataGraphs={hora.atendimentosHora}
  //         total={
  //           hora?.total === 0 ||
  //           hora?.total === 'NaN' ||
  //           hora?.total === undefined ||
  //           hora?.total === null
  //             ? '0'
  //             : hora?.total
  //         }
  //         label="distribuição por hora"
  //         subLabel="atendimentos"
  //         labelModal="Distribuição por hora:"
  //         position="hora*total"
  //         date={hora.horaModal}
  //         tipoAtendimento="SSE"
  //       />
  //     )}
  //   </div>
  // );

  // const renderDia = () => (
  //   <div className={isLoadingDia ? styles.render_spinner_container : null}>
  //     {isLoadingDia ? (
  //       <div className={styles.spinner_style}>
  //         <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
  //       </div>
  //     ) : (
  //       <NewGraphBar
  //         dataGraphs={dia.atendimentosDia}
  //         total={
  //           dia?.total === 0 ||
  //           dia?.total === 'NaN' ||
  //           dia?.total === undefined ||
  //           dia?.total === null
  //             ? '0'
  //             : dia?.total
  //         }
  //         label="dias da semana"
  //         subLabel="atendimentos"
  //         labelModal="dias da semana:"
  //         position="dia*total"
  //         date={dia.diaModal}
  //         tipoAtendimento="SSE"
  //         // otherTitle="Acessos"
  //       />
  //     )}
  //   </div>
  // );

  const renderPorte = () => (
    <div className={isLoadingPorte ? styles.render_spinner_container : null}>
      {isLoadingPorte ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBarPorte
          dataGraphs={porte.atendimentos}
          total={
            porte.total === 0 ||
            porte.total === 'NaN' ||
            porte.total === undefined
              ? '0'
              : porte.total
          }
          label="por porte empresa"
          labelModal="por porte empresa"
          subLabel="atendimentos"
          position="sigla*total"
          slModal={porte.slModal}
          tipoAtendimento="SSE"
        />
      )}
    </div>
  );
  // const renderporteMei = () => (
  //   <div className={isLoadingPorteMei ? styles.render_spinner_container : null}>
  //     {isLoadingPorteMei && (
  //       <div className={styles.spinner_style}>
  //         <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
  //       </div>
  //     )}
  //     {!isLoadingPorteMei && (
  //       <NewGraphBar
  //         dataGraphs={porteMei.atendimentos}
  //         total={
  //           porteMei.total === 0 ||
  //           porteMei.total === 'NaN' ||
  //           porteMei.total === undefined
  //             ? '0'
  //             : porteMei.total
  //         }
  //         label="MEI"
  //         position="mes*total"
  //         subLabel="atendimentos"
  //         labelModal="MEI"
  //         date={porteMei.data}
  //         tipoAtendimento="SSE"
  //       />
  //     )}
  //   </div>
  // );
  // const renderPorteMe = () => (
  //   <div className={isLoadingPorteMe ? styles.render_spinner_container : null}>
  //     {isLoadingPorteMe ? (
  //       <div className={styles.spinner_style}>
  //         <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
  //       </div>
  //     ) : (
  //       <NewGraphBar
  //         dataGraphs={porteMe.atendimentos}
  //         total={
  //           porteMe.total === 0 ||
  //           porteMe.total === 'NaN' ||
  //           porteMe.total === undefined
  //             ? '0'
  //             : porteMe.total
  //         }
  //         label="ME"
  //         position="mes*total"
  //         subLabel="atendimentos"
  //         labelModal="ME"
  //         date={porteMe.data}
  //         tipoAtendimento="SSE"
  //       />
  //     )}
  //   </div>
  // );

  // const renderPorteEpp = () => (
  //   <div className={isLoadingPorteEpp ? styles.render_spinner_container : null}>
  //     {isLoadingPorteEpp ? (
  //       <div className={styles.spinner_style}>
  //         <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
  //       </div>
  //     ) : (
  //       <NewGraphBar
  //         dataGraphs={porteEpp.atendimentos}
  //         total={
  //           porteEpp.total === 0 ||
  //           porteEpp.total === 'NaN' ||
  //           porteEpp.total === undefined
  //             ? '0'
  //             : porteEpp.total
  //         }
  //         label="EPP"
  //         position="mes*total"
  //         subLabel="atendimentos"
  //         labelModal="EPP"
  //         date={porteEpp.data}
  //         tipoAtendimento="SSE"
  //       />
  //     )}
  //   </div>
  // );

  // const renderStatusEnvio = () => (
  //   <div
  //     className={isLoadingStatusEnvio ? styles.render_spinner_container : null}
  //   >
  //     {isLoadingStatusEnvio && (
  //       <div className={styles.spinner_style}>
  //         <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
  //       </div>
  //     )}
  //
  //     {!isLoadingStatusEnvio && (
  //       <GraphBarGrouped
  //         dataGraphs={statusEnvio.atendimentos}
  //         label="Status envio SAS"
  //         porcemPf={
  //           statusEnvio.enviados === 'NaN' || statusEnvio.enviados === undefined
  //             ? 0
  //             : statusEnvio.enviados
  //         }
  //         porcemPj={
  //           statusEnvio.naoEnviados === 'NaN' ||
  //           statusEnvio.naoEnviados === undefined
  //             ? 0
  //             : statusEnvio.naoEnviados
  //         }
  //         position="dia*total"
  //         date={statusEnvio.data}
  //         iten1="enviados"
  //         iten2="não enviados"
  //         tipoAtendimento="SSE"
  //       />
  //     )}
  //   </div>
  // );

  const renderPorcemStatusEnvio = () => (
    <div
      className={
        isLoadingPorcemStatusEnvio ? styles.render_spinner_container : null
      }
    >
      {isLoadingPorcemStatusEnvio ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <PizzaChart
          item1Pf="enviados"
          item2Pj="não enviados"
          label="% envio SAS"
          subLabel1="enviados"
          subLabel2="não enviados"
          porcemPf={
            porcemStatusEnvio.enviados === 'NaN' ||
            porcemStatusEnvio.enviados === undefined
              ? 0
              : porcemStatusEnvio.enviados
          }
          porcemPj={
            porcemStatusEnvio.naoEnviados === 'NaN' ||
            porcemStatusEnvio.naoEnviados === undefined
              ? 0
              : porcemStatusEnvio.naoEnviados
          }
          tipoAtendimento="SSE"
          total1={porcemStatusEnvio.totalEnviados}
          total2={porcemStatusEnvio.totalNaoEnviados}
        />
      )}
    </div>
  );

  // const renderUsuariosApp = () => (
  //   <div
  //     className={isLoadingUsuariosApp ? styles.render_spinner_container : null}
  //   >
  //     {isLoadingUsuariosApp && (
  //       <div className={styles.spinner_style}>
  //         <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
  //       </div>
  //     )}
  //
  //     {!isLoadingUsuariosApp && (
  //       <GraphBarGrouped
  //         dataGraphs={usuariosApp.usuarios}
  //         label="usuários APP"
  //         porcemPf={
  //           usuariosApp.usuario === 'NaN' || usuariosApp.usuario === undefined
  //             ? 0
  //             : usuariosApp.usuario
  //         }
  //         porcemPj={
  //           usuariosApp.naoUsuario === 'NaN' ||
  //           usuariosApp.naoUsuario === undefined
  //             ? 0
  //             : usuariosApp.naoUsuario
  //         }
  //         position="dia*total"
  //         date={usuariosApp.data}
  //         iten1="usuários"
  //         iten2="não usuários"
  //         tipoAtendimento="SSE"
  //       />
  //     )}
  //   </div>
  // );

  const renderPorcemUsuariosApp = () => (
    <div
      className={
        isLoadingPorcemUsuariosApp ? styles.render_spinner_container : null
      }
    >
      {isLoadingPorcemUsuariosApp ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <PizzaChart
          item1Pf="usuários"
          item2Pj="não usuários"
          label="% usuários APP"
          subLabel1="usuários"
          subLabel2="não usuários"
          porcemPf={
            porcemUsuariosApp.usuario === 'NaN' ||
            porcemUsuariosApp.usuario === undefined
              ? 0
              : porcemUsuariosApp.usuario
          }
          porcemPj={
            porcemUsuariosApp.naoUsuario === 'NaN' ||
            porcemUsuariosApp.naoUsuario === undefined
              ? 0
              : porcemUsuariosApp.naoUsuario
          }
          tipoAtendimento="SSE"
          total1={porcemUsuariosApp.totalUsuario}
          total2={porcemUsuariosApp.totalNaoUsuario}
        />
      )}
    </div>
  );

  const renderUfCidadeAgente = () => (
    <div
      className={
        isLoadingUfCidadeAtendente ? styles.render_spinner_container_ufs : null
      }
    >
      {isLoadingUfCidadeAtendente ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <GraphBarCustomLateralTriplo
          dataGraphsUf={ufCidadeAtendente.uf}
          dataGraphsCidade={ufCidadeAtendente.cidade}
          dataGraphsAgente={ufCidadeAtendente.atendente}
          position="uf*total"
          tab1="UF"
          tab2="Cidade"
          tab3="Agente"
          titleUF={ufCidadeAtendente.descUF}
          titleCidade={ufCidadeAtendente.descCidade}
          titleAtendente={ufCidadeAtendente.descAtendente}
        />
      )}
    </div>
  );

  const renderSemAnotacao = () => (
    <div
      className={isLoadingSemAnotacao ? styles.render_spinner_container : null}
    >
      {isLoadingSemAnotacao && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingSemAnotacao && (
        <NewGraphBar
          dataGraphs={semAnotacao.atendimentos}
          total={
            semAnotacao.total === 0 ||
            semAnotacao.total === 'NaN' ||
            semAnotacao.total === undefined
              ? '0'
              : semAnotacao.total
          }
          label="sem anotação"
          position="mes*total"
          subLabel="registros"
          labelModal="sem anotação"
          date={semAnotacao.data}
          tipoAtendimento="SSE"
        />
      )}
    </div>
  );

  const renderSemPlanoAcao = () => (
    <div
      className={isLoadingSemPlanoAcao ? styles.render_spinner_container : null}
    >
      {isLoadingSemPlanoAcao && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingSemPlanoAcao && (
        <NewGraphBar
          dataGraphs={semPlanoAcao.atendimentos}
          total={
            semPlanoAcao.total === 0 ||
            semPlanoAcao.total === 'NaN' ||
            semPlanoAcao.total === undefined
              ? '0'
              : semPlanoAcao.total
          }
          label="sem plano de ação"
          position="mes*total"
          subLabel="atendimentos"
          labelModal="sem plano de ação"
          date={semPlanoAcao.data}
          tipoAtendimento="SSE"
        />
      )}
    </div>
  );

  const renderSemFoto = () => (
    <div className={isLoadingSemFoto ? styles.render_spinner_container : null}>
      {isLoadingSemFoto && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingSemFoto && (
        <NewGraphBar
          dataGraphs={semFoto.atendimentos}
          total={
            semFoto.total === 0 ||
            semFoto.total === 'NaN' ||
            semFoto.total === undefined
              ? '0'
              : semFoto.total
          }
          label="sem foto"
          position="mes*total"
          subLabel="atendimentos"
          labelModal="sem foto"
          date={semFoto.data}
          tipoAtendimento="SSE"
        />
      )}
    </div>
  );

  const renderSemArquivo = () => (
    <div
      className={isLoadingSemArquivo ? styles.render_spinner_container : null}
    >
      {isLoadingSemArquivo && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingSemArquivo && (
        <NewGraphBar
          dataGraphs={semArquivo.atendimentos}
          total={
            semArquivo.total === 0 ||
            semArquivo.total === 'NaN' ||
            semArquivo.total === undefined
              ? '0'
              : semArquivo.total
          }
          label="sem arquivo"
          position="mes*total"
          subLabel="atendimentos"
          labelModal="sem arquivo"
          date={semArquivo.data}
          tipoAtendimento="SSE"
        />
      )}
    </div>
  );

  return (
    <div className={styles.central_container}>
      <div className={styles.render_big_container}>
        <div className={styles.render_big_container2}>
          <div className={styles.render_graph_container1}>
            {renderTotal()}
            {renderHoje()}
            {renderPorte()}
            {/*{renderPorte()}*/}
            {/*{renderHora()}*/}
            {/*{renderDia()}*/}
          </div>
          <div className={styles.render_graph_container1}>
            {/*{renderStatusEnvio()}*/}
            {renderPorcemStatusEnvio()}
            {/*{renderUsuariosApp()}*/}
            {renderPorcemUsuariosApp()}
            {renderSemAnotacao()}
          </div>
        </div>
        <div className={styles.graphBar_lateral_container}>
          {renderUfCidadeAgente()}
        </div>
      </div>
      <div className={styles.render_big_container3}>

        <div className={styles.render_graph_container2}>
          {renderSemPlanoAcao()}
          {renderSemFoto()}
          {renderSemArquivo()}
        </div>
      </div>
    </div>
  );
}
